module.exports = __webpack_public_path__ + "media/assets/images/smart_working/badge-2b4d5ebc2acf66fd293be84b8ded41e1.png";